import appConfig from 'helper/mapBackendConfig';
import noop from 'helper/noop';

const testSuiteRunning = !!(process.env.NODE_ENV === 'test');

const getLoggingFactory = (type: string): ConsoleFunctionType => {
	try {
		if (!appConfig.env.devToolsEnabled) {
			return noop as any;
		}

		if (testSuiteRunning) {
			return noop as any;
		}

		if (window.console && window.console[type]) {
			return (...args: any) => window.console[type](...args);
		}

		return noop as any;
	} catch (err) {
		return noop as any;
	}
};

type ConsoleValueType = string | number | boolean;
type ConsoleFunctionType = (
	a: ConsoleValueType,
	b?: ConsoleValueType,
	c?: ConsoleValueType,
	d?: ConsoleValueType
) => {};

export const log: ConsoleFunctionType = getLoggingFactory('log') || (noop as any);
export const warn: ConsoleFunctionType = getLoggingFactory('warn') || (noop as any);
export const error: ConsoleFunctionType = getLoggingFactory('error') || (noop as any);
export const info: ConsoleFunctionType = getLoggingFactory('info') || (noop as any);
export const group: ConsoleFunctionType = getLoggingFactory('groupCollapsed') || (noop as any);
export const groupEnd: ConsoleFunctionType = getLoggingFactory('groupEnd') || (noop as any);
